import { IconCheckCircleOutline } from '@iwoca/icons';
import { IwocaLogo } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useParams } from 'react-router';

import styles from './ShareLinkOpenBankingStatus.module.css';
import { useGetOpenBankingShareableLink } from '../../api/openBankingShareableLinkApi/useQueryOpenShareableLink';

export type TStatus = 'success' | 'error' | 'expired';

export const ShareLinkOpenBankingStatus = ({ status }: { status: TStatus }) => {
  const { token } = useParams();

  const { openBankingLink } = useGetOpenBankingShareableLink({ token });

  const businessName = openBankingLink?.business_name;

  const renderContent = () => {
    if (status === 'expired') {
      return (
        <>
          <h1 className={styles.largeHeader}>Link expired</h1>
          <p className={styles.text}>
            Looks like that link has expired. Links expire 90 days after they’re
            generated. A new link will need to be generated.
          </p>
        </>
      );
    }

    if (status === 'error') {
      return (
        <>
          <h1 className={styles.largeHeader}>Oops!</h1>
          <p className={styles.text}>
            Looks like this link has already been used for a submitted
            application. Once the application is submitted, this link can’t be
            used again.
          </p>
        </>
      );
    }

    if (status === 'success') {
      return (
        <>
          <IconCheckCircleOutline
            className={styles.checkmark}
            data-testid="check-icon"
          />
          <h1 className={styles.header}>
            You have successfully linked {businessName}’s business bank account.
          </h1>
          <p className={styles.text}>
            Thanks for that. We will let {businessName} know via email that this
            is now complete and they can continue with their application.
          </p>
          <p className={styles.subText}>You may now close this window.</p>
        </>
      );
    }
  };

  return (
    <div className={styles.container}>
      <nav className={styles.nav}>
        <a href="/" data-testid="iwoca-logo">
          <IwocaLogo className={styles.logo} />
        </a>
      </nav>
      <section
        className={clsx(styles.content, {
          [styles.centerContent]: status !== 'success',
        })}
      >
        {renderContent()}
      </section>
    </div>
  );
};
